<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.admin.upload_file.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle; margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>
        <form>
          <div class="form-row d-flex align-items-end">
            <div class="col-md-6">
              <v-file-input
                v-model="file"
                accept=".csv"
                show-size
                :label="$t('lang.admin.upload_file.select_file')"
                outlined
                truncate-length="50"
                prepend-icon="mdi-file"
                color="#FF5800"
              ></v-file-input>
            </div>
            <div class="col-md-6">
              <v-select
                v-model.lazy="areaSelected"
                :items="areaList"
                color="#FF5800"
                :label="$t('lang.admin.device_form.label_select_location')"
                item-color="#FF5800"
                item-text="description"
                item-value="id"
                outlined
              >
              </v-select>
            </div>
          </div>
          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn type="reset" @click="$router.back()" text rounded>{{
                $t("lang.admin.add_user.btn_cancel")
              }}</v-btn>
              <bx-btn type="submit" color="primary" @click="uploadfile">{{
                $t("lang.admin.upload_file.submit")
              }}</bx-btn>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "upload-inventory-csv",
  data() {
    return {
      file: null,
      errors: [],
      areaList: [],
      areaSelected: [],
      success: {
        show: false,
        message: this.$t("lang.admin.upload_file.success_upload"),
      },
      errorLabels: {
        failed: this.$t("lang.messages.label_something_went_wrong"),
        selectFile: this.$t("lang.admin.upload_file.error_select_file"),
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      let location = localStorage.getItem("location");
      let locationId = localStorage.getItem("location_id");
      if (!location || !locationId) {
        try {
          let firstLocation = await this.$api.location.search("", {
            limit: 1,
            offset: 0,
            orderBy: "id",
          });
          location = firstLocation.results[0].description;
          locationId = firstLocation.results[0].id;
        } catch (error) {
          console.log(error);
        }
      }
      this.areaList = await this.$api.area.locationAreaList(locationId);
    },
    async uploadfile() {
      if (this.validate()) {
        try {
          var printResponse = await this.$api.inventories.fileUpload(
            this.areaSelected,
            this.file
          );
          console.log(printResponse)
          if (printResponse) {
            this.file = null;
            this.success.show = true;
            this.$router.push({ name: "inventory-dashboard" });
          }
        } catch (error) {
          console.log(error)
          this.errors.push(error.response.data);
          //this.errors.push(this.errorLabels.failed);
        }
      }
    },
    validate() {
      this.errors = [];
      this.success.show = false;

      let error = false;

      if (!this.file) {
        error = true;
        this.errors.push(this.errorLabels.selectFile);
      }

      if (error) {
        return false;
      }

      return true;
    },
    routePage() {
      setTimeout(() => {
        this.$router.push({ name: "inventory-dashboard" });
      }, 8000);
    },
  },
};
</script>
